angular.module('forms').controller('ConfirmFormCtrl',
    ['$scope', 'FormsService',
        function ($scope, FormsService) {
            'use strict';

            $scope.loading = true;

            $scope.questionnaire = {
                relSurveyPatientId: null,
                patientId: null,
                questionnaireName: ''
            };

            function loadPage() {
                $scope.loading = true;

                var completedForm = FormsService.getCompletedForm();

                $scope.questionnaire.relSurveyPatientId = completedForm.Form.Id;
                $scope.questionnaire.questionnaireName = completedForm.Form.Name;
                $scope.questionnaire.patientId = completedForm.Patient.Id;

                FormsService.clearCompletedForm();
                $scope.loading = false;
            }
            loadPage();

        }]);